var _path, _rect, _circle, _path2, _path3, _path4, _path5, _rect2, _rect3, _path6, _path7, _rect4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle2, _circle3, _path17, _path18, _path19, _path20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawIdeationRe8I2H(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 715 688",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bec063ed-0fa9-413a-bd83-d8526fa41b8c-443",
    "data-name": "Path 421",
    d: "M558.77082,460.48076l26.945,46.669,26.944,46.669h-107.777l26.944-46.669Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#01bf71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "aa6e6c0d-ca3b-4989-ae08-5d6fb21b7d28",
    "data-name": "Rectangle 48",
    x: 50.5,
    y: 263,
    width: 113,
    height: 113,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "e644b8cb-fae5-4de8-b33a-50bfc45133bc",
    "data-name": "Ellipse 68",
    cx: 244.5,
    cy: 118.5,
    r: 72.5,
    fill: "#01bf71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a646102d-3f95-413e-a731-a5030e030d8b-444",
    "data-name": "Path 422",
    d: "M551.90979,345.37477a12,12,0,1,1,12,12A12,12,0,0,1,551.90979,345.37477Zm2,0a10,10,0,1,0,10-10A10,10,0,0,0,553.90979,345.37477Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a7867f82-9da8-49b7-a62f-5fc2df52f7dd-445",
    "data-name": "Path 423",
    d: "M448.59577,554.1118l-17.664-18.938,18.938-17.664,17.664,18.938Zm-14.848-18.84,14.946,16.024,16.024-14.946-14.946-16.024Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "abfd432a-addf-48b7-a638-56871f84cdda-446",
    "data-name": "Path 424",
    d: "M302.70978,284.70577l-14.376-15.413,15.417-14.374,14.376,15.413Zm-12.085-15.333,12.169,13.046,13.042-12.165-12.165-13.042Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "b4b6c2e3-9a65-466b-808f-faa311f7d0ed-447",
    "data-name": "Path 425",
    d: "M504.65979,305.81877a100,100,0,1,1,100-100A100,100,0,0,1,504.65979,305.81877Zm0-198a98,98,0,1,0,98,98A98,98,0,0,0,504.65979,107.81877Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "f21400a3-3aa1-44f2-adc5-de8006399ef9",
    "data-name": "Rectangle 50",
    x: 401.26199,
    y: 309.93746,
    width: 59.647,
    height: 2,
    transform: "translate(-278.03762 459.0125) rotate(-64.336)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "fdf13e27-5b88-4b47-a548-6eba64ef8ea7",
    "data-name": "Rectangle 51",
    x: 492.55471,
    y: 375.91551,
    width: 2,
    height: 129.383,
    transform: "translate(-371.01717 559.14059) rotate(-61.578)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "ec996080-b25c-43f9-95b1-17d83c771fa1-448",
    "data-name": "Path 426",
    d: "M437.65979,482.81877h-146v-146h146Zm-144-2h142v-142h-142Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "e64eb5c0-2762-4bb4-99c9-e384d48b09ae-449",
    "data-name": "Path 427",
    d: "M654.1698,554.81877h-151.019l75.509-130.786Zm-147.555-2h144.09l-72.045-124.786Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "b99807fe-d1e7-4c81-968c-d37ef9c7f61f",
    "data-name": "Rectangle 53",
    y: 686,
    width: 715,
    height: 2,
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "af6ca119-d97b-47e3-8175-f2ef9a50390c-450",
    "data-name": "Path 438",
    d: "M448.4618,729.44976a31.406,31.406,0,0,0,30.327-5.342c10.622-8.916,13.953-23.6,16.662-37.2l8.015-40.228-16.78,11.554c-12.068,8.309-24.407,16.885-32.762,28.92s-12,28.465-5.289,41.488",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "af7a4949-e0bd-4368-90b0-825d65eef9dd-451",
    "data-name": "Path 439",
    d: "M451.0528,780.95377c-2.112-15.387-4.285-30.973-2.8-46.525,1.316-13.812,5.53-27.3,14.109-38.364a63.8194,63.8194,0,0,1,16.374-14.838c1.637-1.033,3.144,1.561,1.514,2.59a60.67228,60.67228,0,0,0-24,28.956c-5.225,13.289-6.064,27.776-5.164,41.893.544,8.537,1.7,17.018,2.861,25.489a1.554,1.554,0,0,1-1.048,1.845,1.509,1.509,0,0,1-1.845-1.048Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "aa567de9-de23-4828-818f-c81c945c4442-452",
    "data-name": "Path 440",
    d: "M590.85379,759.7598a22.26305,22.26305,0,0,0,20.462,7.606c9.693-1.644,17-9.432,23.529-16.778l19.325-21.728-14.4,1.05c-10.359.755-20.98,1.575-30.4,5.94s-17.546,13.1-18.109,23.476",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "fe38c075-c327-4996-87fc-6abec6d8ced7-453",
    "data-name": "Path 441",
    d: "M574.26978,790.05978c3.4-8.175,6.821-16.464,12.033-23.683,4.628-6.412,10.589-11.83,18-14.8a36.378,36.378,0,0,1,12.328-2.575c1.1-.036,1.1,1.674,0,1.71a34.57911,34.57911,0,0,0-20.146,7.319c-6.4,5.028-10.988,11.909-14.615,19.109-2.193,4.354-4.071,8.857-5.94,13.357a.886.886,0,0,1-1.047.605.86.86,0,0,1-.605-1.047Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "ae9d33bb-edce-455d-ba46-f884f02ee286-454",
    "data-name": "Path 442",
    d: "M466.2548,756.26377a23.11894,23.11894,0,0,0,20.144,10.4c10.2-.484,18.7-7.6,26.351-14.358l22.635-19.985-14.98-.717c-10.773-.516-21.824-1-32.085,2.326s-19.724,11.318-21.6,21.939",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "f4a10cc1-a745-4bdf-8c47-a58c703e8c56-455",
    "data-name": "Path 443",
    d: "M445.0828,789.7988c10.168-17.991,21.961-37.986,43.035-44.377a48.02226,48.02226,0,0,1,18.1-1.869c1.922.166,1.442,3.128-.476,2.963a44.61406,44.61406,0,0,0-28.886,7.642c-8.145,5.544-14.487,13.252-19.854,21.425-3.288,5.007-6.233,10.226-9.178,15.438C446.88279,792.6868,444.1308,791.48379,445.0828,789.7988Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "e6c92f99-e819-44b3-a3ab-322ae3ae9c0f-456",
    "data-name": "Path 461",
    d: "M265.64278,757.93277a22.728,22.728,0,0,0,21.947-3.866c7.687-6.452,10.1-17.081,12.058-26.924l5.8-29.112-12.143,8.362c-8.733,6.013-17.662,12.219-23.709,20.929s-8.686,20.6-3.828,30.024",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "a52ffbd1-05e9-4477-9f5c-0a49e3800732-457",
    "data-name": "Path 462",
    d: "M266.68079,793.17875c-1.229-8.953-2.493-18.02-1.631-27.069.766-8.036,3.217-15.885,8.209-22.321a37.13158,37.13158,0,0,1,9.527-8.633c.953-.6,1.829.909.881,1.507a35.29991,35.29991,0,0,0-13.963,16.847c-3.04,7.732-3.528,16.161-3,24.374.317,4.967.988,9.9,1.665,14.83a.9.9,0,0,1-.61,1.074.878.878,0,0,1-1.074-.61Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "a0fb9511-7a08-40c5-84ea-69c7b1520cf5-458",
    "data-name": "Path 481",
    d: "M357.13575,793.26877c-.264-.431-6.485-10.818-8.641-32.388-1.978-19.789-.706-53.144,16.592-99.672,32.772-88.144-7.552-159.264-7.964-159.972l1.989-1.154c.1.18,10.51,18.312,16.656,47.186a205.85619,205.85619,0,0,1-8.526,114.742c-32.716,87.994-8.393,129.649-8.144,130.06Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "f311804e-8539-4d4f-8733-0b334c90657a",
    "data-name": "Ellipse 75",
    cx: 149.29699,
    cy: 430.47997,
    r: 14.945,
    fill: "#01bf71"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a6573fda-74df-4cf8-bcdf-8c67e75bc2cf",
    "data-name": "Ellipse 78",
    cx: 105.61001,
    cy: 546.59399,
    r: 14.945,
    fill: "#01bf71"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "ac75699b-0dec-44f0-aa90-11495e5daa36-459",
    "data-name": "Path 482",
    d: "M364.77277,792.82078s-12.753-31.391,25.505-54.934Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "f26d9f94-3dcd-492b-9651-88d3329d1691-460",
    "data-name": "Path 483",
    d: "M349.08881,792.24974s-3.89-22.374-34-22.182Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "ecf71195-8595-47d1-9f0d-85506c4dd5f7-461",
    "data-name": "Path 484",
    d: "M383.90979,610.18277a12,12,0,1,1,12,12A12,12,0,0,1,383.90979,610.18277Zm2,0a10,10,0,1,0,10-10A10,10,0,0,0,385.90979,610.18277Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "a4f0274e-f5b3-4a0e-a250-2f78ed178189-462",
    "data-name": "Path 485",
    d: "M347.76978,573.14278a12,12,0,1,1,12,12A12,12,0,0,1,347.76978,573.14278Zm2,0a10,10,0,1,0,10-10A10,10,0,0,0,349.76978,573.14278Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#ccc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "baec859b-4664-4042-84b3-8b12dc19197c",
    "data-name": "girl ideation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a8e8d335-bc79-4a28-94f9-614ba261e126-463",
    "data-name": "Path 486",
    d: "M880.0738,544.43579a12.45,12.45,0,0,1-10.453,1.922h0a12.43805,12.43805,0,0,1-8.82409-15.21655q.06464-.24312.13909-.48346a11.99131,11.99131,0,0,1,.684-1.7l-24.452-109.782a9.958,9.958,0,1,1,19.08295-5.69989q.03066.10263.05908.2059l23.082,110.112a12.424,12.424,0,0,1,.683,20.643Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "afd5e353-327d-4eb9-8c44-5bbf6b3b42bc-464",
    "data-name": "Path 487",
    d: "M912.54579,779.96276h-13.262l-6.31-51.155h19.574Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5c5e3ad-7ae7-4273-aee0-b8af9012f8eb-465",
    "data-name": "Path 490",
    d: "M915.9278,792.81879h-42.763v-.541a16.645,16.645,0,0,1,16.643-16.644h26.12Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd288028-f7c4-4616-94da-c314ff6508b8-466",
    "data-name": "Path 491",
    d: "M779.58479,779.54477l-12.618-4.083,9.74-50.613,18.624,6.025Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1a1bcec-635c-498f-8374-9b61c7fe9f7a-467",
    "data-name": "Path 494",
    d: "M778.84681,792.81978l-40.684-13.162.166-.515a16.646,16.646,0,0,1,20.959-10.714h0l24.85,8.039Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7e9d44e-3da8-4950-b68f-3fc4466331ff",
    "data-name": "Ellipse 82",
    cx: 596.923,
    cy: 261.357,
    r: 22.375,
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5c6c761-247a-4902-a0d4-baf8f46a74e0-468",
    "data-name": "Path 495",
    d: "M869.16077,454.15476c3.111-11.557-11.137-47.8-12.3-52.4-5.555-1.282-18.426,1.176-26.339-.453-11.25,9.4-20.2,22.828-26.383,29.2-6.431,6.625-10.577,11.116-3.932,26.622,8.055,18.795,6.265,38.484,6.265,38.484l5.37,47.434s-22.375,62.649-20.585,104.714l-20.586,102.921s6.265,10.74,18.795,5.37c0,0,29.535-52.8,26.85-91.289l32.22-71.6s22.375,68.019,28.64,74.284l16.11,96.659s15.215,4.475,22.375,0c0,0,2.685-93.079-12.53-108.294,0,0-15.215-64.439-11.635-81.444s4.475-42.959-22.375-66.229c0,0,.27.123-8.055-15.215Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af145ef0-0255-4739-8879-297ab98a0d16-469",
    "data-name": "Path 496",
    d: "M850.75476,332.59177h0a19.36119,19.36119,0,0,0-3.737.372,16.379,16.379,0,0,0-7.135-1.644h-.648c-12.486,0-22.607,11.3-22.607,25.235h4.184l.676-5.143.99,5.143h3.485a49.32484,49.32484,0,0,0-1.619,12.643v25.686h6.325l3.662-9.517-.916,9.517h40.658l3.329-8.652-.832,8.652h4.578v-20.169C881.14679,351.45078,867.5398,332.59177,850.75476,332.59177Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea9385fa-bd74-4f9e-87fe-47e8c2aeba8a-470",
    "data-name": "Path 497",
    d: "M804.10279,557.14877a12.449,12.449,0,0,1-10.178-3.061h0a12.438,12.438,0,0,1-.907-17.56659q.17019-.18873.348-.37042a11.99192,11.99192,0,0,1,1.386-1.2l28.351-108.836a9.958,9.958,0,0,1,19.58307,3.6264q-.02079.11207-.04407.2236l-29.727,108.506a12.424,12.424,0,0,1-8.812,18.678Z",
    transform: "translate(-242.15979 -105.81877)",
    fill: "#9f616a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawIdeationRe8I2H);
export default __webpack_public_path__ + "static/media/undraw_ideation_re_8i2h.d997a7676f29df576923465873a5fe6b.svg";
export { ForwardRef as ReactComponent };